export function isDateFacetRequest(request) {
    return request.type === 'dateRange';
}
